module.exports = __webpack_public_path__ + "img/20.afc7e880.svg";